import React from 'react';
import PropTypes from 'prop-types';
import lstrings from '../../../../../utils/LStrings';
import { map } from 'lodash';
import { Panel } from 'react-bootstrap';
import ScrollableAnchor from 'react-scrollable-anchor'
import TablePlain from '../../../../../components/table-plain/TablePlain';
import TableAutomotores from '../../../../../components/panel-bienes/components/TableAutomotores';
import PermissionChecker from '../../../../../components/permission-checker/PermissionChecker';
import 'react-bootstrap-table/css/react-bootstrap-table.css';

class PanelBienesPersonales extends React.Component {

    onRequestInfo = (infoKey, infoTitle) => {
        this.props.onRequestInfo(lstrings.bienespersonales_title, infoTitle);
    }

    render() {
        let titulo = <h2><i className="fa fa-home"></i> {lstrings.bienespersonales_title}</h2>;

        return (
            <ScrollableAnchor id={'panel-bienespersonales'}>
                <Panel collapsible defaultExpanded header={titulo}>
                    <PermissionChecker infoKey='propiedades' infoTitle='Propiedades' data={this.props.info.propiedades}
                        onRequestInfo={this.onRequestInfo} hidePanels={this.props.hidePanels} noCount>
                        {this.props.info.propiedades && <TablePlain columns={['Ubicacion', 'Superficie terreno', 'Superficie cubierta']}
                            rows={map(this.props.info.propiedades.datos, (item, ix) => <tr key={ix}>
                                <td>{item.ubicacion}</td>
                                <td>{item.sup_terreno} m2</td>
                                <td>{item.sup_cubierta} m2</td>
                            </tr>)} />}
                    </PermissionChecker>

                <PermissionChecker infoKey='automotores' infoTitle={lstrings.automotores_title} data={this.props.info.automotores} onRequestInfo={this.onRequestInfo} hidePanels={this.props.hidePanels}>
                        <TableAutomotores autos={this.props.info.automotores} embargos={this.props.info.autosembargos} onRequestInfo={this.onRequestInfo} hidePanels={this.props.hidePanels} />
                </PermissionChecker>

                <PermissionChecker infoKey='automotores_historial' infoTitle={lstrings.automotores_historial_title} data={this.props.info.automotores_historial} onRequestInfo={this.onRequestInfo} hidePanels={this.props.hidePanels}>
                        <TableAutomotores autos={this.props.info.automotores_historial} embargos={this.props.info.autosembargos} onRequestInfo={this.onRequestInfo} hidePanels={this.props.hidePanels}/>
                </PermissionChecker>


                </Panel>
            </ScrollableAnchor>
        );
    }
}

PanelBienesPersonales.propTypes = {
    info: PropTypes.object,
    onRequestInfo: PropTypes.func,
    hidePanels: PropTypes.any
};

export default PanelBienesPersonales;



// WEBPACK FOOTER //
// ./src/scenes/personas/components/personas-detalle/components/PanelBienesPersonales.js